import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const ContentLayout = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flex: 1, backgroundColor: '#EEF1EC' }}>
            <Outlet />
        </Box>
        <Footer />
    </Box>
);

export default ContentLayout;
